<template>
	<div>
		<button @click="send()">아이프레임호출</button>
		<br />
		<iframe v-if="loaded" :src="iframe.src" :style="iframe.style" height="100%" width="100%" frameborder="0" id="iframe"></iframe>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loaded: false,
			iframe: {
				//src: "http://biz.eghishc.com",
				//src:"http://52.231.90.16:8010/Checkup/start/im/MB/pNdjVXxmrJ/80/bdGPmsXAfRUxehRjVOPAuw==",
				//src: "http://tab.eghishc.co.kr:7779/iframetest.html",
				//src: "http://localhost:8080/iframetest.html",
				//src: "http://52.231.90.16:8010/Checkup/start/IM/MB/pNdjVXxmrJ",
				src: this.$route.params.url,
				style: null,
				wrapperStyle: null
			}
		};
	},
	mounted() {
		let vm = this;
		//window.addEventListener("message", (e) => {

		window.addEventListener('message', function (e) {
			// console.log("e", e.data.jsondata.hasSmoking);

			if (e.data.function == 'saveData') {
				let temp = JSON.parse(e.data.jsonData);
				console.log(temp.hasSmoking);
			} else if (e.data.function == 'iframeClose') {
				vm.$router.replace({
					name: '대기리스트'
				});
			}
			//console.log("e", JSON.parse(e.data.jsondata));
			//if (e.data.action == "change") {
			//  alert("1");
			//console.log(this);
			//}
		});

		this.iframe.style = {
			position: 'absolute',
			width: window.innerWidth,
			height: window.innerHeight
		};
		this.iframe.wrapperStyle = {
			overflow: 'hidden'
		};
		this.loaded = true;
	},
	methods: {
		test() {
			alert('iframe');
		},
		send() {
			alert('send');

			const frame = document.getElementById('iframe').contentWindow;
			console.log(frame);

			let jsonData = {
				hasOld: 'Y', //노인검진대상자
				hasLady: 'Y', //여성암검진 대사아자
				hasLife: 'Y', //생활습관대사아자
				hasCancer: 'Y', //암검진 대상자
				hasSmoking: 'Y', //흡연대상자
				hasDrinking: 'Y', //음주대상자
				hasCognitive: 'Y', //인지기능장애
				hasDepression: 'Y' //우울증
			};
			frame.postMessage(jsonData, '*');
		}
	}
};
</script>
